import {
	product0,
	product1,
	product2,
	product3,
	product4,
	product5,
	product6,
} from "./Assests";

export const brandNames = [
	{
		name: "Domyos",
	},
	{
		name: "Artengo",
	},
	{
		name: "Quechua",
	},
	{
		name: "Kalenji",
	},
];

export const categoryNames = [
	{
		name: "shirts",
	},
	{
		name: "shoes",
	},
	{
		name: "trousers",
	},
	{
		name: "backpack",
	},
	{
		name: "sunglasses",
	},
];
export const sliderImages = [
	{
		title: "First Slider Image",
		description: "This is the first image",
		urls: product0,
	},
	{
		title: "second Slider Image",
		description: "This is the first image",
		urls: product1,
	},
	{
		title: "third Slider Image",
		description: "This is the first image",
		urls: product0,
	},
	{
		title: "Fourth Slider Image",
		description: "This is the first image",
		urls: product1,
	},
];
export const productImages = [
	{
		imageUrl: product3,
	},
	{
		imageUrl: product4,
	},
	{
		imageUrl: product5,
	},
	{
		imageUrl: product6,
	},
];
